import { Component, OnInit, ViewChild, ModuleWithComponentFactories } from '@angular/core';
import { FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { Router, ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';

import { AlertService, ProctorService, OpentokService } from '../_services';
import { Globals } from '../_helpers';
import { SearchFilterPipe } from '../_pipes';
import * as moment from 'moment';


export class MyErrorStateMatcher implements ErrorStateMatcher {
    isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        const isSubmitted = form && form.submitted;
        return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
    }
}
@Component({
    selector: 'app-examlist',
    templateUrl: './exam-link.component.html',
    // styleUrls: ['./exam-link.component.css'],

})
export class ExamLinkComponent implements OnInit {

    statusMsg: string = '';
    batch_name: string = '';
    exam_name: string = '';
    exam_date;
    localData = {};
    localBatch = {};
    localStudent = {};
    loading = false;
    submitted = false;
    returnUrl: string;
    examsData = [];
    query: string = '';

    batchid;


    isReporting: boolean = true;
    isProctering: boolean = true;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private proctorService: ProctorService,
        private alertService: AlertService,
        private globals: Globals,
        private spinner: NgxSpinnerService
    ) { }

    ngOnInit() {
        localStorage.clear();
        this.batchid = atob(this.route.snapshot.paramMap.get("batch_id"));
        this.getExamDetailsByLink();


    }
    dat
    time

    private getExamDetailsByLink() {
        this.submitted = true;
        this.spinner.show();
        this.proctorService.getBatchExamLink(this.globals.root_url, this.batchid)
            .pipe(first())
            .subscribe(
                data => {
                    if (data.code == 1000) {
                        this.examsData = data.exams;
                        this.dat = data.date
                        this.time = data.time
                        let sec = this.time.split(':')

                        let mstime = ( parseInt(sec[0]) * 3600) + (parseInt(sec[1]) * 60) + (parseInt(sec[2]))
                        

                        var linkInitTime = moment(this.dat).add(mstime,'s')
                        var curdate = moment()

                        if(curdate.valueOf() < linkInitTime.valueOf()) {
                            this.spinner.hide();
                            this.loading = false;
                            this.globals.statusOpen('Link Will be available Soon.', '/dashboard');
                            return false;
                        }

                        var expireDate = linkInitTime.add(36, 'hour')


                        if (curdate.valueOf() > expireDate.valueOf()) {

                            this.spinner.hide();
                            this.loading = false;
                            this.globals.statusOpen('Link Expired', '/dashboard');
                            return false;

                        }
                    }
                    else if (data.status == 'COM_TOKEN_ERROR') {
                        this.loading = false;

                        this.router.navigateByUrl('/login');
                    }
                    else {
                        this.loading = false;
                        this.globals.statusOpen(data.status, '/dashboard');
                    }
                    this.spinner.hide();
                },
                error => {
                    this.alertService.error(error);
                    this.loading = false;
                    this.spinner.hide();
                }
            );
    }




    public studentAssessor(exam_id: any, type: string, exam_name: string, start_date, batch_name: string) {
        let localBatch = {
            viewType: type,
            exam_name: exam_name,
            exam_date: start_date,
            batch_name: batch_name,
            batchId: this.batchid,
        }

        localStorage.setItem('localBatch', JSON.stringify(localBatch));
        // localStorage.setItem('localBatch', JSON.stringify({is_proctoring:1}));

        localStorage.setItem('localExam', JSON.stringify({ exam_id: exam_id }));
        localStorage.setItem('currentUser', JSON.stringify({ usercode: 'qwert12y', link: true, batchId: this.batchid }));

        this.router.navigateByUrl('/proctor-view/' + type);

    }

}


